/** Provisional typographic signature (guide §2): Inter SemiBold, petroleum (mint in dark). Not translated. */
export function LumoraSignature({ size = 'md' }: { size?: 'md' | 'lg' }) {
  return <span className={`${size === 'lg' ? 'text-h2' : 'text-h3'} font-semibold tracking-normal text-action`}>Lumora</span>
}
